export const MODAL_TYPES = {
    DeungiMemberModal: "DeungiMemberModal",
};
